module.exports = __webpack_public_path__ + "static/media/Icon - powerplant.59ed04ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Icon - powerplant.svg
// module id = 72
// module chunks = 0